export class CreateOpportunityCrmOracle {
    constructor({
        partyId = null,
        channel = null,
        names = null,
        surname = null,
        secondLastName = null,
        email = null,
        tECId_c = null,
        tECFrom_c = null,
        dEC_c = null,
        numDocument = null,
        documentType = null,
        cellphone = null,
        clientType = null,
        whichEnsure = null,
        housingType = null,
    } = {}) {
        this.KeyContactId = partyId;
        this.StatusCode = "OPEN";
        this.chECCanal_c = channel;
        this.chOrigen_c = "1831";
        this.chFuente_c = "PV_API_EC";
        this.chECPriorizacionEstado_c = "solicitar";
        this.chECAutoTipifEstado_c = "solicitar";
        this.chECEnvioEstado_c = "solicitar";
        this.tECId_c = tECId_c;
        this.tECFrom_c = tECFrom_c;
        this.dEC_c = dEC_c;
        this.chTipifArbol_c = "EC";
        this.chTipifProducto_c = "HOGAR_EC";
        this.ChildRevenue = [
            {
                ItemNumber: "HOGAR",
                chProducto_c: "HOGAR",
            },
        ];
        this.chECFase_c = "inicio";
        this.tPerNumDoc_c = numDocument;
        this.chPerTipoDoc_c = documentType;
        this.tPerNombre_c = names;
        this.tPerApellidoPaterno_c = surname;
        this.tPerApellidoMaterno_c = secondLastName;
        this.tPerCorreoElectronico_c = email;
        this.tPerTelefonoCelular_c = cellphone;
        this.chHogarTipoContratante_c = clientType;
        this.chHogarTipoSeguro_c = whichEnsure;
        this.chHogarTipoInmueble_c = housingType;
        this.tECConsentimiento_c = true;
    }

    applySetNullAndCleanData() {
        Object.entries(this).forEach(item => {
            this[item[0]] = item[1] === "" || item[1] === undefined ? null : item[1];
        });
    }
}
